import { AnyAppEvent, AppEvent } from "../appEvent.types";

const eventName = "issue-tickets" as const;

export type IssueTicketsEventData = {
  tickets: Array<{
    quantity: number;
    exhibitorId?: string | null;
    commercialId?: string | null;
    visitorId?: string | null;
  }>;
  eventId: string;
};
export type IssueTicketsEvent = AppEvent<
  typeof eventName,
  IssueTicketsEventData
>;

export const isIssueTicketsEvent = (
  event: AnyAppEvent
): event is IssueTicketsEvent => event.name === eventName;

export { eventName as issueTickets };
